import Model from './Model'

export default class Avatar extends Model {
  resource() {
    return 'image'
  }
}
